import type {SketchLineObject} from '../../../../../mesh/sketch';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {SketchLineMultiRelationConstraint} from './SketchLineMultiRelationConstraint';

let count = 0;

/**
 * 判断对象是否为垂直关系。
 * @param value 待判断对象。
 * @returns 是否为垂直关系。
 */
export function isLinePerpendicularConstraint(value: object): value is LinePerpendicularConstraint {
    return Reflect.get(value, 'isLinePerpendicularConstraint') === true;
}

/**
 * 两直线垂直关系定义。
 *
 * 几何计算由统一参数公式完成；本类不选择被驱动端点。
 */
export class LinePerpendicularConstraint extends SketchLineMultiRelationConstraint<SketchLineObject> {
    /** 运行时类型标记。 */
    public readonly isLinePerpendicularConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Perpendicular;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '垂直';
    }
}
